import { logger as LOG } from '@sweetgreen/garnish';

export const tagManagerLogger = LOG.extend('TagManager');

LOG.disable('TagManager');
